import { create } from "zustand";

interface MobileChromeState {
  bottomNavSuppressed: number;
  suppressBottomNav: () => void;
  releaseBottomNav: () => void;
}

export const useMobileChrome = create<MobileChromeState>((set) => ({
  bottomNavSuppressed: 0,
  suppressBottomNav: () => set((s) => ({ bottomNavSuppressed: s.bottomNavSuppressed + 1 })),
  releaseBottomNav: () => set((s) => ({ bottomNavSuppressed: Math.max(0, s.bottomNavSuppressed - 1) })),
}));

export function bottomNavHidden(): boolean {
  return useMobileChrome.getState().bottomNavSuppressed > 0;
}
